import axios from "axios";
import { ApiResponse } from "../interfaces/response";
import { AvailableSchedule } from "../interfaces/availableResponse";
import { Appointment } from "../interfaces/appointment";

const API_URL =
  "https://7jpfphjjix3kvkebml3wozns7a0vkavr.lambda-url.sa-east-1.on.aws";

export const getAvailableHours = async (
  establishmentId: string,
  date: string,
  serviceDuration: number
): Promise<AvailableSchedule[]> => {
  try {
    const response = await axios.get<ApiResponse<AvailableSchedule[]>>(
      `${API_URL}/scheduler/available?establishment_id=${establishmentId}&date=${date}&service_duration=${serviceDuration}`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching available hours:", error);
    throw error;
  }
};

export const createAppointment = async (appointmentData: Appointment): Promise<any> => {
  try {
    const response = await axios.post<ApiResponse<any>>(
      `${API_URL}/appointment`,
      appointmentData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("Error creating appointment:", error);
    throw error;
  }
};
